<template>
  <div class="px-4">
    <dynamic-zone-renderer v-if="content" :components="content.components" :add-paddings="false" />
    <div>
      <div v-for="channel in getElectromagneticChannels" :key="channel.channel">
        <name-linking-dynamic-zone-renderer
            v-if="channel && channelsContent[channel.channel]"
            :title="channel.name"
            :channel="channel"
            :components="channelsContent[channel.channel].components"
            :planets="chart?.chart?.planets || []"
            :names="[chart.meta.person1.name, chart.meta.person2.name]"
            use-reverse-color
        />
      </div>
      <div v-if="getElectromagneticChannels.length === 0 && !fetching" class="font-500">
        There are no electromagnetic connections in this chart.
      </div>

      <slot name="unlock-prompt"/>
      <ProgressChecker class="pt-3" type="companionship" id="2" :has-prev="hasPrev" :has-next="hasNext"
                       :order="order"
                       @prevSection="$emit('prevSection')"
                       @nextSection="$emit('nextSection')"/>
    </div>
  </div>

</template>

<script>

import DynamicZoneRenderer from "../../renderer/DynamicZoneRenderer";
import {mapState} from "vuex";
import NameLinkingDynamicZoneRenderer from "../../renderer/NameLinkingDynamicZoneRenderer.vue";
import ProgressChecker from "@/components/charts/analysis/progress/ProgressChecker.vue";
import PartnershipAnalysis from "@/mixins/PartnershipAnalysis";

export default{
  mixins: [PartnershipAnalysis],
  components: {ProgressChecker, NameLinkingDynamicZoneRenderer, DynamicZoneRenderer},
  data(){
    return{
      audioKey: 0,
      tab: 0,
      content: null,
      channelsContent: {}
    }
  },

  computed:{
    ...mapState({
      chart: state => state.charts.chart
    }),
  },
  created(){
    this.getIntroduction('electromagnetic');
    for (let channel of this.getElectromagneticChannels) {
      this.getContentForChannel('electromagnetic', 'channelsContent', channel.channel);
    }
  },
}
</script>